import React from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import Card from 'common/card/Card';

const SpotListEventCTA = ({destinationTitle, onClick}) => {
    return (
        <Card className="SpotList-event-cta">
            <p>Going to an event at {destinationTitle}?</p>
            <Button color="primary" onClick={onClick}>
                View Upcoming Events
            </Button>
        </Card>
    );
};

SpotListEventCTA.propTypes = {
    destinationTitle: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

export default SpotListEventCTA;
